<template>
  <div class="about">
		<div class="pg-header">
			<div><label class="title">{{tagName}}勿访</label></div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>{{tagName?tagName:{1:'门诊',2:'出院'}[filter.datasources]}}排期管理</span>|
					<span>勿访</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>姓名<el-input size="small" maxlength="6" style="width:160px;margin:0 16px 0 4px;" v-model.trim="filter.name" @keyup.enter.native="handleFilter(0, $event)"></el-input></label>
						<label>住院号
							<el-input size="small" style="width:80px" v-model.trim="filter.admissionNumber" @keyup.enter.native="handleFilter(4, $event)"></el-input>
						</label>
						<label>身份证号<el-input size="small" maxlength="18" style="width:200px;margin:0 16px 0 4px;" v-model.trim="filter.cardNum" @keyup.enter.native="handleFilter(1, $event)"></el-input></label>
						<label>{{
								{1:'门诊',2:'出院'}[filter.datasources]
								}}诊断
							<el-input size="small" style="width:160px;margin:0 16px 0 4px;" v-model.trim="filter.outHospitalDiagnosis" @keyup.enter.native="handleFilter(4, $event)"></el-input>
						</label>
						<br/>
						<div style="display: inline-block;">科室
							<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.outHospitalDepartmentId" @change="handleFilter(3, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
						<label>{{
								{1:'就诊',2:'出院'}[filter.datasources]
								}}时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:260px;margin:16px 12px 0 4px;" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date" :picker-options="pickerOptions" @change="handleFilter(2, $event)"></el-date-picker>
						</label>
						<label>操作时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:260px;margin:16px 16px 0 4px !important;" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.updateDate" :picker-options="pickerOptions" @change="handleFilter(6, $event)"></el-date-picker>
						</label>
						<template>
							<el-checkbox v-model="filter.showMyself" @change="handleFilter(5,$event)">本人患者</el-checkbox>
						</template>
						<el-button class="flr" size="mini" icon="el-icon-search" round @click="handleFilter" style="margin-top: 20px;">搜索</el-button>
						<el-button class="btn-export flr" size="mini" round @click="exportReport" style="margin:20px 10px 0 0;"><i class="icon-export"></i>导出</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable"  header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column prop="name" label="姓名" width="120">
						<template slot-scope="scope"><router-link class="noline" target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3, fid: scope.row.recordId,datasources:scope.row.datasources,t2:2,id:scope.row.id}}"><span class="fc key"><i class="icon-fav small" v-if="scope.row.star == 1"></i>{{ scope.row.name }}</span></router-link></template>
					</el-table-column>
					<el-table-column prop="admissionNumber" label="住院号" width="140"></el-table-column>
					<el-table-column prop="cardNum" label="身份证号" width="140"></el-table-column>
					<el-table-column label="性别" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.sex == 1">男</span>
							<span v-else>女</span>
						</template>
					</el-table-column>
					<el-table-column prop="age" label="年龄" width="80">
						<template slot-scope="scope">
							<span>{{scope.row.age}}岁</span>
						</template>
					</el-table-column>
					
					<el-table-column prop="outHospitalDiagnosisName" :label="filter.datasources==1?'门诊诊断':'出院诊断'" show-overflow-tooltip></el-table-column>
					<el-table-column prop="outHospitalDepartment" label="科室"></el-table-column>
					<el-table-column prop="" label="来源" width="100">
						<template slot-scope="scope">
							<span v-if="scope.row.datasources == 0">院中</span>
							<span v-if="scope.row.datasources == 1">门诊</span>
							<span v-if="scope.row.datasources == 2">出院</span>
						</template>
					</el-table-column>
					<el-table-column prop="date" :label="filter.datasources==1?'就诊时间':'出院时间'" width="180"></el-table-column>
					<el-table-column prop="updateTime" label="操作时间" width="180"></el-table-column>
					<el-table-column prop="docName" label="责任医师" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column label="操作人" width="120" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.reviserName != null">{{ scope.row.reviserName }}</span>
							<span v-else>自动勿访</span>
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="160">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="查看" placement="top" :enterable="false"><router-link target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3, fid: scope.row.recordId,datasources:scope.row.datasources,t2:2,id:scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip>					
								<el-popconfirm confirmButtonText='确定' title="确定回退到待排期吗？" @confirm="saveForm(scope.row)">
									<el-tooltip content="回退" slot="reference" placement="top" :enterable="false"><i class="icon-sync"></i></el-tooltip>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>	
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>				
				
		</div>

  </div>
</template>

<script>
import api from '@/service/api.js';
import utils from '@/service/utils';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';

export default {
  mixins: [mixin],
	data(){
		return {
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				cardNum: '',
				outHospitalCloseDateStart: '',
				outHospitalCloseDateEnd: '',
				outHospitalDepartmentId: '',
				outHospitalDiagnosis: '',
				schedulingState: '3',
				data: [],
				showMyself : false,
				pageNumber: 1,
				pageSize: 10,
				datasources:2,
				updateDateStart:'',
				updateDateEnd:'',
				updateDate:[],
				tagId:''
			},
			form: {
				detailId: 0,
				datasources: ''
			},			
			deptList: [],
			tagName:''
		}
	},
	created() {
		let query = this.$route.query;
		if(query.date){
			if (typeof(query.date)=='string') {
				this.filter.updateDateStart = dayjs(query.date).format('YYYY-MM-DD 00:00:00')
				this.filter.updateDateEnd = dayjs(query.date).format('YYYY-MM-DD 23:59:59');
				this.filter.updateDate = [this.filter.updateDateStart, this.filter.updateDateEnd];
			}else{
				this.filter.outHospitalCloseDateStart = dayjs(query.date[0]).format('YYYY-MM-DD 00:00:00')
				this.filter.outHospitalCloseDateEnd = dayjs(query.date[1]).format('YYYY-MM-DD 23:59:59');
				this.filter.date = [this.filter.outHospitalCloseDateStart, this.filter.outHospitalCloseDateEnd];
			}
		}
		if (query.state) {
			this.filter.schedulingState = query.state.toString();
		}
		// 0531 新增 tagId,datasources筛选
		this.filter.tagId=query.tagId?query.tagId:'';
		this.filter.datasources=query.datasources?query.datasources:'';
		this.filter.outHospitalDepartmentId=query.depId?Number(query.depId):'';

		this.$watch(
			() => this.$route.query, // 监听的对象是 $route.query
			(newQuery, oldQuery) => {
				this.tagName='';
				this.filter={
					name: '',
					cardNum: '',
					outHospitalCloseDateStart: '',
					outHospitalCloseDateEnd: '',
					outHospitalDepartmentId:newQuery.depId?Number(newQuery.depId):'',
					outHospitalDiagnosis: '',
					schedulingState: '3',
					data: [],
					showMyself : false,
					pageNumber: 1,
					pageSize: 10,
					updateDateStart:'',
					updateDateEnd:'',
					updateDate:[],
					datasources:newQuery.datasources?newQuery.datasources:2,
					tagId:newQuery.tagId?newQuery.tagId:''
				}
				this.loadList();
			}
		);
		this.loadList();
		// 获取 科室下拉
		api.getDeptDropdown({departmentType:this.filter.datasources==1?1:0}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.deptList = res.data;
			}
		})
	},
	mounted() {
		// 监听页面显示隐藏
		document.addEventListener('visibilitychange', this.handleVisiable)  
	},  
	destroyed() {  
		document.removeEventListener('visibilitychange', this.handleVisiable)  
	},	
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getScheduleList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.date = dayjs(item.outHospitalCloseDate).format('YYYY-MM-DD HH:mm:ss');
					item.updateTime = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
					item.cardNum = utils.hideIdCard(item.cardNum);
				})
				this.list.data = res.data;
			}
			// 0530 新增
			if(this.filter.tagId != ''){
				let res2 = await api.getTag(this.filter.tagId);
				if (res2.code == 1000 && res2.data) {
					this.tagName = res2.data.name;
				}
			}
			this.isLoading = false;
		},
		// 回退
		async saveForm(item) {
			let res;
			this.form.detailId = item.id;
			this.form.datasources = item.datasources;
			this.form.schedulingState = this.filter.schedulingState;

			this.isLoading = true;
			res = await api.rollbackScheduleState(this.form);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.loadList();
		},		
		handleTab(){
			// 切换列表类型
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			switch(key) {
				case 2:
					if (this.filter.date) {
						this.filter.outHospitalCloseDateStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.outHospitalCloseDateEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.outHospitalCloseDateStart = '';
						this.filter.outHospitalCloseDateEnd = '';						
					}
					break;
				case 6:
					if (this.filter.updateDate) {
						this.filter.updateDateStart = dayjs(this.filter.updateDate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.updateDateEnd = dayjs(this.filter.updateDate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.updateDateStart = '';
						this.filter.updateDateEnd = '';						
					}
					break;
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		exportReport() {
			this.filter.pageSize=this.list.total;
			let url = api.exportOuthospitalReport(this.filter);
			const tempLink = document.createElement('a');
			tempLink.style.display = 'none';
			tempLink.href = url;
			tempLink.target = '_blank';
			document.body.appendChild(tempLink);
			tempLink.click()
			document.body.removeChild(tempLink);
			this.filter.pageSize=10;

		},
		handleVisiable(e){
			// 关闭新开页面，回到列表页，刷新列表数据
			if(e.target.visibilityState == "visible"){
				this.loadList()
			}
		},
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
.def-key{
	display: block;
	.el-checkbox{
		font-weight:400 ;
		color: #808080;
		
	}
}
</style>
